import { instance } from "../axios"
import type { AxiosRequestConfig } from "axios"

//============================ sms ============================//

// 取得 sms 素材各種狀態的數量
export function getSmsStatusCount(config: AxiosRequestConfig = {}) {
    return instance.request({
        url: "/assets/sms/counts/",
        method: "get",
        ...config,
    })
}

// 取得 sms
export function getSmsList(config: AxiosRequestConfig = {}) {
    return instance.request({ url: "/assets/sms/", method: "get", ...config })
}

// 取得單個 sms
export function getSms(smsId: string, config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/assets/sms/${smsId}/`,
        method: "get",
        ...config,
    })
}

// 新增 sms
export function createSms(config: AxiosRequestConfig = {}) {
    return instance.request({ url: "/assets/sms/", method: "post", ...config })
}

// 編輯 sms
export function updateSms(smsId: string, config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/assets/sms/${smsId}/`,
        method: "put",
        ...config,
    })
}

// 複製 sms
export function copySms(smsId: string, config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/assets/sms/${smsId}/copy/`,
        method: "post",
        ...config,
    })
}

// 停用 sms
export function disableSms(smsId: string, config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/assets/sms/${smsId}/disable/`,
        method: "put",
        ...config,
    })
}

//  刪除 sms
export function deleteSms(smsId: string, config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/assets/sms/${smsId}/`,
        method: "delete",
        ...config,
    })
}

// 送審 sms
export function submitSms(smsId: string, config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/assets/sms/${smsId}/submit/`,
        method: "post",
        ...config,
    })
}

// 審核 sms
export function reviewSms(smsId: string, config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/assets/sms/${smsId}/review/`,
        method: "post",
        ...config,
    })
}

// 取得 sms 審核紀錄
export function getSmsReviewers(uuid: string, config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/assets/sms/${uuid}/reviewers/`,
        method: "get",
        ...config,
    })
}

// 預覽 sms
export function sendSmsPreview(config: AxiosRequestConfig = {}) {
    return instance.request({
        url: "/assets/sms/send-preview/",
        method: "post",
        ...config,
    })
}

// 取得 sms 短網址服務商
export function getShortUrlServices(config: AxiosRequestConfig = {}) {
    return instance.request({
        url: "/assets/sms/short-url/services/",
        method: "get",
        ...config,
    })
}

//============================ APP推播 ============================//

// 取得 app push 素材各狀態數量
export function getAppPushStatusCount(config: AxiosRequestConfig = {}) {
    return instance.request({
        url: "/assets/push/counts/",
        method: "get",
        ...config,
    })
}

// 取得 APP推播
export function getAppPushes(config: AxiosRequestConfig = {}) {
    return instance.request({
        url: "/assets/push/",
        method: "get",
        ...config,
    })
}

// 取得單個 APP推播
export function getAppPush(appPushId: string, config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/assets/push/${appPushId}/`,
        method: "get",
        ...config,
    })
}

// 新增 APP推播
export function createAppPush(config: AxiosRequestConfig = {}) {
    return instance.request({ url: "/assets/push/", method: "post", ...config })
}

// 編輯 APP推播
export function updateAppPush(
    appPushId: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request({
        url: `/assets/push/${appPushId}/`,
        method: "put",
        ...config,
    })
}

// 複製 APP推播
export function copyAppPush(
    appPushId: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request({
        url: `/assets/push/${appPushId}/copy/`,
        method: "post",
        ...config,
    })
}

// 停用 APP推播
export function disableAppPush(
    appPushId: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request({
        url: `/assets/push/${appPushId}/disable/`,
        method: "put",
        ...config,
    })
}

// 刪除 APP推播
export function deleteAppPush(
    appPushId: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request({
        url: `/assets/push/${appPushId}/`,
        method: "delete",
        ...config,
    })
}

// 送審 APP推播
export function submitAppPush(
    appPushId: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request({
        url: `/assets/push/${appPushId}/submit/`,
        method: "post",
        ...config,
    })
}

// 審核 APP推播
export function reviewAppPush(
    appPushId: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request({
        url: `/assets/push/${appPushId}/review/`,
        method: "post",
        ...config,
    })
}

// 取得 APP推播 審核紀錄
export function getAppPushReviewers(
    uuid: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request({
        url: `/assets/push/${uuid}/reviewers/`,
        method: "get",
        ...config,
    })
}

// 取得 APP推播 推播人員列表
export function getAppPushReceivers(config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/assets/push/receivers/`,
        method: "get",
        ...config,
    })
}

// APP推播 測試推播
export function testAppPush(config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/assets/push/test/`,
        method: "post",
        ...config,
    })
}

//============================ EDM ============================//

// 取得 edm 偏好設定
export function getEdmPreferences(config: AxiosRequestConfig = {}) {
    return instance.request({
        url: "/assets/edm/preferences/",
        method: "get",
        ...config,
    })
}

// 更新 edm 偏好設定
export function updateEdmPreferences(config: AxiosRequestConfig = {}) {
    return instance.request({
        url: "/assets/edm/preferences/",
        method: "put",
        ...config,
    })
}

// 取得 edm 素材各狀態數量
export function getEdmStatusCount(config: AxiosRequestConfig = {}) {
    return instance.request({
        url: "/assets/edm/counts/",
        method: "get",
        ...config,
    })
}

// 取得 edm 素材列表
export function getEdmList(config: AxiosRequestConfig = {}) {
    return instance.request({
        url: "/assets/edm/",
        method: "get",
        ...config,
    })
}

// 取得單個 edm 素材
export function getEdm(edmAssetId: string, config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/assets/edm/${edmAssetId}/`,
        method: "get",
        ...config,
    })
}

// 新增 edm 素材
export function createEdm(config: AxiosRequestConfig = {}) {
    return instance.request({
        url: "/assets/edm/",
        method: "post",
        ...config,
    })
}

// 編輯 edm 素材
export function updateEdm(edmAssetId: string, config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/assets/edm/${edmAssetId}/`,
        method: "put",
        ...config,
    })
}

// 複製 edm 素材
export function copyEdm(edmAssetId: string, config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/assets/edm/${edmAssetId}/copy/`,
        method: "post",
        ...config,
    })
}

// 停用 edm 素材
export function disableEdm(
    edmAssetId: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request({
        url: `/assets/edm/${edmAssetId}/disable/`,
        method: "put",
        ...config,
    })
}

// 刪除 edm 素材
export function deleteEdm(edmAssetId: string, config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/assets/edm/${edmAssetId}/`,
        method: "delete",
        ...config,
    })
}

// 送審 edm 素材
export function submitEdm(edmAssetId: string, config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/assets/edm/${edmAssetId}/submit/`,
        method: "post",
        ...config,
    })
}

// 審核 edm 素材
export function reviewEdm(edmAssetId: string, config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/assets/edm/${edmAssetId}/review/`,
        method: "post",
        ...config,
    })
}

// 取得 edm 素材 審核紀錄
export function getEdmReviewers(uuid: string, config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/assets/edm/${uuid}/reviewers/`,
        method: "get",
        ...config,
    })
}

// 取得 預覽收件人列表
export function getEdmReceivers(config: AxiosRequestConfig = {}) {
    return instance.request({
        url: "/assets/edm/receivers/",
        method: "get",
        ...config,
    })
}

// 新增 預覽收件人
export function addEdmReceiver(config: AxiosRequestConfig = {}) {
    return instance.request({
        url: "/assets/edm/receivers/",
        method: "post",
        ...config,
    })
}

// 刪除 預覽收件人
export function deleteEdmReceiver(
    uuid: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request({
        url: "/assets/edm/receivers/" + uuid + "/",
        method: "delete",
        ...config,
    })
}

// 預覽 EDM
export function sendEdmPreview(config: AxiosRequestConfig = {}) {
    return instance.request({
        url: "/assets/edm/send-preview/",
        method: "post",
        ...config,
    })
}

//============================ 素材管理 ============================//

// 取得素材狀態
export function getAssetStatus(config: AxiosRequestConfig = {}) {
    return instance.request({
        url: "/assets/status/",
        method: "get",
        ...config,
    })
}

// 取得個人化變數
export function getMemberMessageParams(config: AxiosRequestConfig = {}) {
    return instance.request({
        url: "/assets/member-message-params/",
        method: "get",
        ...config,
    })
}
